const releasesPT = {
    "view": {
        "table": {
            "title": "Sua lista de lançamentos",
            "column": {
                "name": "Nome",
                "artist": "Artista",
                "catalogue_number": "Nº Cat.",
                "release_date": "Data de Lançamento",
                "status": "Status",
                "store_urls": "URLs das Lojas",
                "qc": "QC",
                "pre_scan": "Pre-Scan",
                "alert": "Alerta",
                "flagged": "Marcado",
                "action": "Ação"
            },
            "label": {
                "status_ready": "Pronto",
                "status_approval": "Submissão na Fila",
                "status_takedown_request": "Pedido de Remoção",
                "status_taken_down": "Removido",
                "status_distributed": "Distribuído",
                "status_locked": "Em Progresso - Bloqueado",
                "status_delivering": "Entregando",
                "status_unlocked": "Por Favor Edite",
                "status_offline": "Offline",
                "status_re_delivery-delivery": "Re-entrega",
                "status_re_delivery-editing": "Edição de Re-entrega",
                "status_unknown": "Status Desconhecido"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "dropdown": {
                "item": {
                    "action": "Ação",
                    "distribute": "Distribuir",
                    "viewRelease": "Ver Lançamento",
                    "editReleaseMetadata": "Editar Metadados do Lançamento",
                    "editTracks": "Editar Faixas",
                    "takedown": "Remover",
                    "submitEditing": "Enviar Edição",
                    "deliveredList": "Lista Entregue",
                    "copyEanUpc": "Copiar EAN/UPC"
                },
                "message": {
                    "submitInformationTooltip": "Você ainda não forneceu suas informações completas, portanto, não pode distribuir os lançamentos. Para fazer isso, por favor Envie Suas Informações.",
                    "submitMetadataTooltip": "Por favor, envie os metadados de todas as Faixas para Distribuir o Lançamento.",
                    "submitEditingMetadataTooltip": "Por favor, envie os metadados de todas as faixas, para Enviar as Edições.",
                    "submitEditingTokenRequiredTooltip": "É necessário pelo menos 1 token para enviar a edição para a re-entrega. <2>Comprar tokens</2>.",
                    "blacklistedArtistTooltip": "Este lançamento não pode ser distribuído porque contém uma ou mais faixas de um artista blacklisted. Por favor, entre em contato com nosso time de suporte para mais informações.",
                    "distributionDisabledPreScanInProgress": "Por favor, aguarde o pre-scan ser concluído primeiro para distribuir o lançamento.",
                    "distributionDisabledPreScanNotDone": "Por favor, execute o pre-scan primeiro para distribuir o lançamento.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Por favor, envie a declaração do pre-scan primeiro para distribuir o lançamento.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "Você tem certeza de que deseja editar os metadados?",
                        "description": {
                            "point1": "<strong>Isso mudará seus metadados e pode afetar o lançamento.</strong>",
                            "point2": "Prossiga apenas se tiver certeza absoluta.",
                            "point3": "<strong>POR FAVOR NÃO</strong> edite metadados apenas para testar e explorar."
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Eu entendo"
                        }
                    },
                    "distribute": {
                        "header": "Você tem certeza de que todas as informações inseridas são válidas e representam totalmente este lançamento?",
                        "description": {
                            "point1": "Após esta ação, seu lançamento será verificado e, se as informações estiverem corretas, será distribuído nas datas oficiais e exclusivas de distribuição.",
                            "point2": "Ao confirmar e aceitar este formulário, você está aceitando e cumprindo totalmente os <1>Termos de Distribuição</1>, <3>Termos de Uso</3> e <5>Política de Privacidade</5>.",
                            "point3": "Ao confirmar e aceitar este formulário, você está confirmando indiscutivelmente que o lançamento do conteúdo enviado com ativos pertencentes, arquivos de áudio e metadados, pertence exclusivamente a você ou está totalmente licenciado para seu selo.",
                            "point4": "Por meio deste, você aceita totalmente que será o único responsável por qualquer informação enganosa, uso não licenciado, atividade ilegal ou qualquer tipo de disputa.",
                            "flaggedTracksTerms": {
                                "header": "Termos de Faixas Marcadas",
                                "point1": "Por favor, note: <strong>'{{releaseName}}'</strong> contém uma ou mais faixas marcadas, uma taxa de <strong>15 €</strong> por faixa marcada se aplica para entregar o lançamento ao <strong>Spotify</strong>. Como você optou por não pagar essa taxa no momento, o lançamento não será entregue ao Spotify. Ao confirmar e aceitar este formulário, você reconhece e aceita estes termos.",
                                "point2": "No futuro, se optar por entregar o lançamento ao <strong>Spotify</strong>, você pode ir à seção Marcada na tabela de Lançamentos e seguir as instruções de pagamento."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Declaração de Streaming Artificial",
                                "point1": "<strong>1.</strong> Eu entendo e concordo plenamente em não me envolver em qualquer forma de streaming artificial, incluindo o uso de bots, fazendas de streaming ou qualquer método que manipule métricas de DSP.",
                                "point2": "<strong>2.</strong> Não pagarei ou oferecerei pagamento por colocações em playlists, nem trabalharei com terceiros prometendo colocações garantidas — entendo que isso é considerado fraude e golpe.",
                                "point3": "<strong>3.</strong> Reconheço que tais ações podem resultar em rescisão imediata, perda de royalties, reivindicações legais, penalidades contratuais e taxas, e relatórios para DSPs e autoridades.",
                                "point4": "<strong>4.</strong> Também garanto informar e educar qualquer artista ou cliente com quem trabalho sobre essas regras e garantir que eles cumpram.",
                                "point5": "<strong>5.</strong> Entendo que, se me envolver em streaming artificial, meus dados KYC, incluindo meu nome completo, endereço, carteira de identidade e outras informações pessoais, podem ser compartilhados com os departamentos legais dos DSPs, como os do Spotify, Apple Music e outros.",
                                "point6": "<strong>6.</strong> Aceito total responsabilidade legal por quaisquer violações.",
                                "acknowledgment": "Eu, por meio deste, reconheço e concordo em cumprir os termos acima de Streaming Artificial, e aceito total responsabilidade legal por quaisquer violações."
                            }
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar e Aceitar"
                        }
                    },
                    "takedown": {
                        "header": "Você tem certeza de que deseja remover este lançamento de todas as lojas?",
                        "description": {
                            "point1": "Esta ação é irreversível.",
                            "point2": "Ao remover este lançamento, você está cumprindo os <1>Termos de Distribuição</1>, <3>Termos de Uso</3> e <5>Política de Privacidade</5>."
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar e Aceitar"
                        }
                    },
                    "finishEditing": {
                        "header": "Você tem certeza de que todas as informações inseridas são válidas e representam totalmente este lançamento?",
                        "description": {
                            "point1": "Após esta ação, seu lançamento será verificado e, se as informações estiverem corretas, será redistribuído para os parceiros DSP. <strong>NOTA, apenas METADADOS serão enviados para DSPs, conteúdos como IMAGEM e arquivos de ÁUDIO não podem ser atualizados desta forma.</strong>",
                            "point2": "Ao confirmar e aceitar este formulário, você está aceitando e cumprindo totalmente os <1>Termos de Uso</1> e os Termos do nosso Acordo de Distribuição Exclusiva.",
                            "point3": "Ao confirmar e aceitar este formulário, você está aceitando e cumprindo totalmente a <1>Política de Privacidade</1>.",
                            "point4": "Ao confirmar e aceitar este formulário, você está confirmando indiscutivelmente que o lançamento do conteúdo enviado com ativos pertencentes, arquivos de áudio e metadados, pertence exclusivamente a você ou está totalmente licenciado para seu selo.",
                            "point5": "Por meio deste, você aceita totalmente que será o único responsável por qualquer informação enganosa, uso não licenciado, atividade ilegal ou qualquer tipo de disputa."
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar e Aceitar"
                        }
                    }
                }
            },
            "message": {
                "success": "Lançamento atualizado!",
                "declaration_success": "Declaração enviada para revisão do administrador.",
                "declaration_error": "Algo deu errado ao enviar a declaração, por favor tente novamente mais tarde.",
                "pre_scan_declaration_success": "Declaração do pre-scan enviada com sucesso.",
                "pre_scan_declaration_error": "Algo deu errado ao enviar a declaração do pre-scan, por favor tente novamente mais tarde.",
                "pre_scan_success": "Lançamento enviado com sucesso para scan.",
                "pre_scan_error": "Algo deu errado ao realizar o scan do lançamento, por favor tente novamente mais tarde.",
                "linkCopied": "Link copiado para a área de transferência!"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "Você gastou sua permissão de distribuição de faixas. Para enviar mais faixas, por favor, atualize sua conta ou entre em contato com nossa equipe de suporte.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para aproveitar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para aproveitar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor entre em contato com a equipe de suporte para mais informações.",
            "subscriptionUpgradeReleaseTransfer": "Seu plano de assinatura atual não suporta o recurso de transferência de lançamento. Se você estiver transferindo um catálogo anterior maior ou desejar transferir mais catálogos de selos para o Music Link com apenas alguns cliques, por favor, <1>atualize</1> seu plano de assinatura.",
            "noAccessReleaseTransfer": "Atualmente, você não tem permissão para usar o recurso de transferência de lançamento. Se você estiver transferindo um catálogo anterior maior ou desejar transferir mais catálogos de selos para o Music Link com apenas alguns cliques, não hesite em entrar em contato com nossa equipe de suporte.",
            "accountBlacklisted": "Sua conta foi blacklisted após a revisão, pois encontramos que as informações associadas com sua conta estão vinculadas a um dos usuários internacionalmente blacklisted em nosso sistema. Como resultado, desativamos a funcionalidade de distribuição para sua conta.",
        }
    },
    "add": {
        "title": "Adicionar Novo Lançamento",
        "form": {
            "label": {
                "required": "Obrigatório",
                "name": "Nome do Lançamento",
                "version": "Versão do Lançamento",
                "subuser": "Sub-Usuário",
                "label": "Selo",
                "copyright": "Direitos Autorais ©",
                "copyright_year": "Ano dos Direitos Autorais ©",
                "copyright_publisher": "Direitos Autorais ℗",
                "copyright_publisher_year": "Ano dos Direitos Autorais ℗",
                "genre": "Gênero",
                "subgenre": "Subgênero",
                "catalog_number": "Número do Catálogo",
                "artwork": "Arte",
                "artwork_alt": "Sua arte",
                "new_release": "É um Novo Lançamento?",
                "original_release_date": "Data de lançamento original",
                "official_release_date": "Data de lançamento oficial",
                "backcatalog": "Catálogo Anterior",
                "assisted_dates": "Datas Assistidas",
                "exclusive_store_release_date": "Data de lançamento exclusiva na loja",
                "additional_metadata": "Metadados Adicionais",
                "release_description": "Descrição do Lançamento",
                "release_language": "Idioma do Nome do Lançamento",
                "auto_detect_language": "Detecção Automática (Idioma)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Gerar automaticamente (ean)",
                "territories": "Territórios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARAÇÃO DE ID DE CONTEÚDO DO YOUTUBE",
                "youtube_declaration_intro": "Para optar pelo ID de Conteúdo do YouTube para este lançamento, você deve garantir que atenda a TODOS os seguintes requisitos:",
                "youtube_declaration_certify": "Eu, <strong>{{firstName}} {{lastName}}</strong>, sob pena de perjúrio, certifico que as informações acima são verdadeiras e corretas.",
                "youtube_declaration_point1": "Tenho direitos suficientes sobre o material.",
                "youtube_declaration_point2": "Todo o conteúdo de referência é suficientemente distinto.",
                "youtube_declaration_point3": "Tenho referências individuais para cada peça de propriedade intelectual.",
                "youtube_declaration_point4": "O conteúdo entregue <strong>não</strong> é nenhum dos seguintes: domínio público, conteúdo licenciado não exclusivamente, clipes de outras fontes usados sob princípios de uso justo, imagens de jogabilidade de vídeo (por outro que não o editor do jogo), gravações de karaokê, remasterização sem permissão, gravações semelhantes, conteúdo dublado, aceleração/desaceleração, efeitos sonoros, trilhas sonoras, mixagens contínuas de DJ, mashups, listas de contagem regressiva ou qualquer outro conteúdo proibido ou inelegível nomeado nas Diretrizes de ID de Conteúdo do YouTube listadas abaixo.",
                "youtube_declaration_account": "Entendo que minha conta pode ser desativada e encerrada em caso de violações. Além disso, compreendo plenamente que posso ser responsável por quaisquer taxas, danos, despesas legais ou quaisquer outras despesas que possam surgir.",
                "youtube_declaration_guidelines": "De acordo com as <1><strong>Diretrizes de ID de Conteúdo do YouTube</strong></1>, o conteúdo enviado através deste lançamento é totalmente elegível para o ID de Conteúdo do YouTube.",
                "youtube_content_id_eligible": "Confirmo que meu conteúdo é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "youtube_content_id_not_eligible": "Meu conteúdo não é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "immersive_audio": "Este Lançamento tem Áudio Imersivo"
            },
            "placeholder": {
                "version": "Deixe em branco se não tiver certeza ou se for um lançamento regular",
                "select_date": "Selecionar data...",
                "copyright": "Normalmente o nome do seu selo",
                "copyright_publisher": "Normalmente o nome do seu selo",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "label": "Selecionar Selo...",
                "subuser": "Selecionar Sub-usuário...",
                "genre": "Selecionar Gênero...",
                "subgenre": "Selecionar Subgênero...",
                "ean": "Deixe em branco se não tiver certeza!",
                "release_description": "Algumas palavras sobre seu lançamento. Sem links e endereços de e-mail, por favor. Máximo de 600 caracteres"
            },
            "help_text": {
                "name": "Por favor, não use adições ao nome do lançamento, como LP e EP.",
                "version": "Alguns lançamentos são lançados em mais de uma versão, se for o caso, insira o nome da versão. Se seu lançamento for original/padrão, ignore este campo.",
                "subuser": "Nota: Use este menu suspenso apenas se quiser adicionar um lançamento para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado.",
                "label": "Nota: Selecione seu Selo no menu suspenso se ele já existir no sistema, caso contrário, crie seu Selo clicando <1>aqui</1>, uma vez criado, você poderá selecioná-lo no menu suspenso.",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "artwork": "Envie formatos JPG, resolução apenas 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data de lançamento original para todas as lojas do mundo.",
                "official_release_date": "Data de lançamento oficial para todas as lojas do mundo.",
                "release_language": "Em qual idioma o nome do lançamento está escrito? Por favor, verifique novamente se não tiver certeza. Se esta entrada estiver errada, algumas lojas como iTunes e Apple Music rejeitarão o lançamento.",
                "ean": "O Código Universal de Produto ou Número de Artigo Europeu para o lançamento. Códigos válidos têm 13 dígitos. Se você não tiver o seu próprio, geraremos um para você."
            },
            "option": {
                "yes": "Sim",
                "no": "Não",
                "no_exclusive": "Sem exclusividade",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pré-venda 1 semana",
                "preorder_2weeks": "Pré-venda 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Selecionar...",
                "worldwide": "Mundial",
                "only_selected": "Apenas países selecionados",
                "all_except_selected": "Todos, exceto países selecionados"
            },
            "message": {
                "track_name_required": "Por favor, digite o nome da faixa",
                "mix_name_required": "Por favor, digite o nome do mix",
                "mix_name_invalid": "O nome do mix só pode consistir em letras, números, espaços e sublinhados",
                "artist_required": "Por favor, selecione o artista",
                "artist_type_required": "Por favor, selecione o tipo de artista",
                "catalog_duplicate": "O número do catálogo '{{number}}' já foi usado. Por favor, insira outro.",
                "ean_duplicate": "Este número EAN está associado a outro lançamento. Por favor insira outro.",
                "artist_added": "Novo Artista foi adicionado!",
                "track_limit": "Seu limite atual de faixas é insuficiente. Por favor, atualize sua conta ou entre em contato com o suporte.",
                "select_day": "Por favor, selecione um dia.",
                "form_error": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "ean_invalid": "O valor não é um EAN válido. Se você estiver inserindo um novo lançamento, deixe este campo em branco e geraremos um EAN para você. Se você estiver enviando um catálogo anterior e o EAN não for válido, por favor, entre em contato conosco.",
                "ean_length": "O número EAN deve ter 13 caracteres",
                "artwork_invalid": "Este arquivo é inválido, por favor, certifique-se de que a imagem tenha extensão .jpg, Cores RGB, dimensões 3000 X 3000 e até 4MB.",
                "track_invalid": "Este arquivo é inválido, por favor, certifique-se de codificar corretamente seu arquivo em 16 bits, 44.1 Khz.",
                "artworkSwapTokenRequiredTooltip": "Seu saldo atual de tokens é insuficiente. É necessário pelo menos 1 token para trocar a arte de capa."
            },
            "button": {
                "reset": "Redefinir",
                "save_only": "Salvar apenas",
                "save_and_continue": "Salvar e continuar"
            },
            "modal": {
                "assisted_days": {
                    "header": "Você tem certeza de que deseja ignorar as melhores práticas de data de lançamento?",
                    "body": "Por favor, note que ao selecionar esta opção, sua data de lançamento pode não ser aceita pelas lojas ou ingerida e publicada na data selecionada. Além disso, você está reduzindo fortemente as oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_created": {
                    "header": "Lançamento criado!",
                    "body": "Seu lançamento foi criado com sucesso!",
                    "button": {
                        "close": "Fechar"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Atualizar Lançamento",
        "form": {
            "label": {
                "required": "Obrigatório",
                "name": "Nome do Lançamento",
                "version": "Versão do Lançamento",
                "subuser": "Sub-Usuário",
                "label": "Selo",
                "copyright": "Direitos Autorais ©",
                "copyright_year": "Ano dos Direitos Autorais ©",
                "copyright_publisher": "Direitos Autorais ℗",
                "copyright_publisher_year": "Ano dos Direitos Autorais ℗",
                "genre": "Gênero",
                "subgenre": "Subgênero",
                "catalog_number": "Número do Catálogo",
                "artwork": "Arte",
                "artwork_alt": "Sua arte",
                "new_release": "É um Novo Lançamento?",
                "original_release_date": "Data de lançamento original",
                "official_release_date": "Data de lançamento oficial",
                "backcatalog": "Catálogo Anterior",
                "assisted_dates": "Datas Assistidas",
                "exclusive_store_release_date": "Data de lançamento exclusiva na loja",
                "additional_metadata": "Metadados Adicionais",
                "release_description": "Descrição do Lançamento",
                "release_language": "Idioma do Nome do Lançamento",
                "auto_detect_language": "Detecção Automática (Idioma)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Gerar automaticamente (ean)",
                "territories": "Territórios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARAÇÃO DE ID DE CONTEÚDO DO YOUTUBE",
                "youtube_declaration_intro": "Para optar pelo ID de Conteúdo do YouTube para este lançamento, você deve garantir que atenda a TODOS os seguintes requisitos:",
                "youtube_declaration_certify": "Eu, <strong>{{firstName}} {{lastName}}</strong>, sob pena de perjúrio, certifico que as informações acima são verdadeiras e corretas.",
                "youtube_declaration_point1": "Tenho direitos suficientes sobre o material.",
                "youtube_declaration_point2": "Todo o conteúdo de referência é suficientemente distinto.",
                "youtube_declaration_point3": "Tenho referências individuais para cada peça de propriedade intelectual.",
                "youtube_declaration_point4": "O conteúdo entregue <strong>não</strong> é nenhum dos seguintes: domínio público, conteúdo licenciado não exclusivamente, clipes de outras fontes usados sob princípios de uso justo, imagens de jogabilidade de vídeo (por outro que não o editor do jogo), gravações de karaokê, remasterização sem permissão, gravações semelhantes, conteúdo dublado, aceleração/desaceleração, efeitos sonoros, trilhas sonoras, mixagens contínuas de DJ, mashups, listas de contagem regressiva ou qualquer outro conteúdo proibido ou inelegível nomeado nas Diretrizes de ID de Conteúdo do YouTube listadas abaixo.",
                "youtube_declaration_account": "Entendo que minha conta pode ser desativada e encerrada em caso de violações. Além disso, compreendo plenamente que posso ser responsável por quaisquer taxas, danos, despesas legais ou quaisquer outras despesas que possam surgir.",
                "youtube_declaration_guidelines": "De acordo com as <1><strong>Diretrizes de ID de Conteúdo do YouTube</strong></1>, o conteúdo enviado através deste lançamento é totalmente elegível para o ID de Conteúdo do YouTube.",
                "youtube_content_id_eligible": "Confirmo que meu conteúdo é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "youtube_content_id_not_eligible": "Meu conteúdo não é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "immersive_audio": "Este Lançamento tem Áudio Imersivo"
            },
            "placeholder": {
                "version": "Deixe em branco se não tiver certeza ou se for um lançamento regular",
                "select_date": "Selecionar data...",
                "copyright": "Normalmente o nome do seu selo",
                "copyright_publisher": "Normalmente o nome do seu selo",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "label": "Selecionar Selo...",
                "subuser": "Selecionar Sub-usuário...",
                "genre": "Selecionar Gênero...",
                "subgenre": "Selecionar Subgênero...",
                "ean": "Deixe em branco se não tiver certeza!",
                "release_description": "Algumas palavras sobre seu lançamento. Sem links e endereços de e-mail, por favor. Máximo de 600 caracteres"
            },
            "help_text": {
                "name": "Por favor, não use adições ao nome do lançamento, como LP e EP.",
                "version": "Alguns lançamentos são lançados em mais de uma versão, se for o caso, insira o nome da versão. Se seu lançamento for original/padrão, ignore este campo.",
                "subuser": "Nota: Use este menu suspenso apenas se quiser adicionar um lançamento para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado.",
                "label": "Nota: Selecione seu Selo no menu suspenso se ele já existir no sistema, caso contrário, crie seu Selo clicando <1>aqui</1>, uma vez criado, você poderá selecioná-lo no menu suspenso.",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "artwork": "Envie formatos JPG, resolução apenas 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data de lançamento original para todas as lojas do mundo.",
                "official_release_date": "Data de lançamento oficial para todas as lojas do mundo.",
                "release_language": "Em qual idioma o nome do lançamento está escrito? Por favor, verifique novamente se não tiver certeza. Se esta entrada estiver errada, algumas lojas como iTunes e Apple Music rejeitarão o lançamento.",
                "ean": "O Código Universal de Produto ou Número de Artigo Europeu para o lançamento. Códigos válidos têm 13 dígitos. Se você não tiver o seu próprio, geraremos um para você."
            },
            "option": {
                "yes": "Sim",
                "no": "Não",
                "no_exclusive": "Sem exclusividade",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pré-venda 1 semana",
                "preorder_2weeks": "Pré-venda 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Selecionar...",
                "worldwide": "Mundial",
                "only_selected": "Apenas países selecionados",
                "all_except_selected": "Todos, exceto países selecionados"
            },
            "message": {
                "track_name_required": "Por favor, digite o nome da faixa",
                "mix_name_required": "Por favor, digite o nome do mix",
                "mix_name_invalid": "O nome do mix só pode consistir em letras, números, espaços e sublinhados",
                "artist_required": "Por favor, selecione o artista",
                "artist_type_required": "Por favor, selecione o tipo de artista",
                "catalog_duplicate": "O número do catálogo '{{number}}' já foi usado. Por favor, insira outro.",
                "ean_duplicate": "Este número EAN está associado a outro lançamento. Por favor insira outro.",
                "artist_added": "Novo Artista foi adicionado!",
                "track_limit": "Seu limite atual de faixas é {{trackLimit}} faixa(s). Para enviar mais faixas, por favor, atualize sua conta ou entre em contato com nossa equipe de suporte.",
                "select_day": "Por favor, selecione um dia.",
                "form_error": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "ean_invalid": "O valor não é um EAN válido. Se você estiver inserindo um novo lançamento, deixe este campo em branco e geraremos um EAN para você. Se você estiver enviando um catálogo anterior e o EAN não for válido, por favor, entre em contato conosco.",
                "ean_length": "O número EAN deve ter 13 caracteres",
                "artwork_invalid": "Este arquivo é inválido, por favor, certifique-se de que a imagem tenha extensão .jpg, Cores RGB, dimensões 3000 X 3000 e até 4MB.",
                "track_invalid": "Este arquivo é inválido, por favor, certifique-se de codificar corretamente seu arquivo em 16 bits, 44.1 Khz."
            },
            "button": {
                "reset": "Redefinir",
                "submit_form": "Enviar Formulário",
                "save_and_continue": "Salvar e continuar"
            },
            "modal": {
                "assisted_days": {
                    "header": "Você tem certeza de que deseja ignorar as melhores práticas de data de lançamento?",
                    "body": "Por favor, note que ao selecionar esta opção, sua data de lançamento pode não ser aceita pelas lojas ou ingerida e publicada na data selecionada. Além disso, você está reduzindo fortemente as oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_updated": {
                    "header": "Lançamento atualizado!",
                    "body": "Seu lançamento foi atualizado com sucesso!",
                    "button": {
                        "close": "Fechar"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Transferir Lançamento",
        "view": {
            "title": "Transferir Lançamento",
            "label": {
                "searchBy": "Buscar Por",
                "upc": "Número UPC",
                "url": "URL do Lançamento na Loja",
                "name": "Nome do Lançamento",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Buscando Detalhes do Lançamento..."
            },
            "placeholder": {
                "upc": "Digite o Número UPC/EAN do Lançamento, por exemplo, 5055964352523",
                "url": "Digite a URL do Lançamento na Loja, por exemplo, open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ou www.deezer.com/en/album/413370367",
                "name": "Digite o Nome do Lançamento, por exemplo, Warrior"
            },
            "help_text": {
                "upc": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify ou Deezer.",
                "url": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify ou Deezer.",
                "name_spotify": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify.",
                "name_deezer": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Deezer."
            },
            "button": {
                "reset": "Redefinir",
                "transfer": "Transferir"
            },
            "message": {
                "release_exists": "Um lançamento com este número UPC já pertence a outro usuário dentro da plataforma Music Link. Por favor, importe apenas lançamentos que pertencem inteiramente à sua empresa e selo. Se você acredita que alguém pegou seu lançamento sem permissão, por favor, entre em contato com nossa equipe de suporte."
            }
        },
        "modal": {
            "header": "Termos de Transferência de Lançamento",
            "ownership_warranty": {
                "header": "Garantia de Propriedade",
                "body": {
                    "point1": "Ao aceitar estes termos, você reconhece e garante que possui a propriedade legal ou representa o proprietário legítimo de todo o conteúdo, incluindo o lançamento e as músicas associadas, fornecidas aqui.",
                    "point2": "Você afirma que nenhum material protegido por direitos autorais ou propriedade intelectual pertencente a terceiros está incorporado neste lançamento."
                }
            },
            "non_infringement_warranty": {
                "header": "Garantia de Não Infringimento",
                "body": {
                    "point1": "Ao prosseguir, você confirma expressamente que o conteúdo enviado neste lançamento não infringe quaisquer direitos de terceiros, incluindo, mas não se limitando a, direitos autorais, marcas registradas ou quaisquer outros direitos proprietários.",
                    "point2": "Você concorda em não incluir qualquer material de fontes externas sem a devida autorização."
                }
            },
            "exclusivity_declaration": {
                "header": "Declaração de Exclusividade",
                "body": {
                    "point1": "Ao consentir com estes termos, você se compromete que o conteúdo apresentado neste lançamento é exclusivo de sua propriedade ou representação autorizada, e não foi oferecido ou lançado para qualquer outra entidade ou plataforma.",
                    "point2": "Você assume total responsabilidade por qualquer violação de exclusividade e entende que tal violação pode levar a consequências legais."
                }
            },
            "legal_consequences_awareness": {
                "header": "Consciência das Consequências Legais",
                "body": {
                    "point1": "É crucial compreender que qualquer violação dos termos e garantias descritos neste modal ou termos pode levar a severas ramificações legais.",
                    "point2": "Essas penalidades podem incluir, mas não se limitam a, responsabilidades financeiras substanciais, medidas judiciais e danos à reputação.",
                    "point3": "Ao aceitar estes termos, você reconhece a seriedade de cumprir as obrigações declaradas e reconhece que o descumprimento pode resultar em ações legais sendo movidas contra você ou sua organização."
                }
            },
            "button": {
                "cancel": "Cancelar",
                "agree": "Eu Concordo"
            }
        },
        "form": {
            "title": "Transferir Lançamento",
            "label": {
                "required": "Obrigatório",
                "name": "Nome do Lançamento",
                "version": "Versão do Lançamento",
                "subuser": "Sub-Usuário",
                "label": "Selo",
                "copyright": "Direitos Autorais ©",
                "copyright_year": "Ano dos Direitos Autorais ©",
                "copyright_publisher": "Direitos Autorais ℗",
                "copyright_publisher_year": "Ano dos Direitos Autorais ℗",
                "genre": "Gênero",
                "subgenre": "Subgênero",
                "catalog_number": "Número do Catálogo",
                "artwork": "Arte",
                "artwork_alt": "Sua arte",
                "new_release": "É um Novo Lançamento?",
                "original_release_date": "Data de lançamento original",
                "official_release_date": "Data de lançamento oficial",
                "backcatalog": "Catálogo Anterior",
                "assisted_dates": "Datas Assistidas",
                "exclusive_store_release_date": "Data de lançamento exclusiva na loja",
                "additional_metadata": "Metadados Adicionais",
                "release_description": "Descrição do Lançamento",
                "release_language": "Idioma do Nome do Lançamento",
                "auto_detect_language": "Detecção Automática (Idioma)",
                "ean": "EAN / UPC",
                "territories": "Territórios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARAÇÃO DE ID DE CONTEÚDO DO YOUTUBE",
                "youtube_declaration_intro": "Para optar pelo ID de Conteúdo do YouTube para este lançamento, você deve garantir que atenda a TODOS os seguintes requisitos:",
                "youtube_declaration_certify": "Eu, <strong>{{firstName}} {{lastName}}</strong>, sob pena de perjúrio, certifico que as informações acima são verdadeiras e corretas.",
                "youtube_declaration_point1": "Tenho direitos suficientes sobre o material.",
                "youtube_declaration_point2": "Todo o conteúdo de referência é suficientemente distinto.",
                "youtube_declaration_point3": "Tenho referências individuais para cada peça de propriedade intelectual.",
                "youtube_declaration_point4": "O conteúdo entregue <strong>não</strong> é nenhum dos seguintes: domínio público, conteúdo licenciado não exclusivamente, clipes de outras fontes usados sob princípios de uso justo, imagens de jogabilidade de vídeo (por outro que não o editor do jogo), gravações de karaokê, remasterização sem permissão, gravações semelhantes, conteúdo dublado, aceleração/desaceleração, efeitos sonoros, trilhas sonoras, mixagens contínuas de DJ, mashups, listas de contagem regressiva ou qualquer outro conteúdo proibido ou inelegível nomeado nas Diretrizes de ID de Conteúdo do YouTube listadas abaixo.",
                "youtube_declaration_account": "Entendo que minha conta pode ser desativada e encerrada em caso de violações. Além disso, compreendo plenamente que posso ser responsável por quaisquer taxas, danos, despesas legais ou quaisquer outras despesas que possam surgir.",
                "youtube_declaration_guidelines": "De acordo com as <1><strong>Diretrizes de ID de Conteúdo do YouTube</strong></1>, o conteúdo enviado através deste lançamento é totalmente elegível para o ID de Conteúdo do YouTube.",
                "youtube_content_id_eligible": "Confirmo que meu conteúdo é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "youtube_content_id_not_eligible": "Meu conteúdo não é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "immersive_audio": "Este Lançamento tem Áudio Imersivo"
            },
            "placeholder": {
                "version": "Deixe em branco se não tiver certeza ou se for um lançamento regular",
                "select_date": "Selecionar data...",
                "copyright": "Normalmente o nome do seu selo",
                "copyright_publisher": "Normalmente o nome do seu selo",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "label": "Selecionar Selo...",
                "subuser": "Selecionar Sub-usuário...",
                "genre": "Selecionar Gênero...",
                "subgenre": "Selecionar Subgênero...",
                "ean": "Deixe em branco se não tiver certeza!",
                "release_description": "Algumas palavras sobre seu lançamento. Sem links e endereços de e-mail, por favor. Máximo de 600 caracteres"
            },
            "help_text": {
                "name": "Por favor, não use adições ao nome do lançamento, como LP e EP.",
                "version": "Alguns lançamentos são lançados em mais de uma versão, se for o caso, insira o nome da versão. Se seu lançamento for original/padrão, ignore este campo.",
                "subuser": "Nota: Use este menu suspenso apenas se quiser adicionar um lançamento para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado.",
                "label": "Nota: Selecione seu Selo <strong>{{labelName}}</strong> no menu suspenso se ele já existir no sistema, caso contrário, crie seu Selo <strong>{{labelName}}</strong> clicando <5>aqui</5>, uma vez criado, você poderá selecioná-lo no menu suspenso.",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "artwork": "Envie formatos JPG, resolução apenas 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data de lançamento original para todas as lojas do mundo.",
                "official_release_date": "Data de lançamento oficial para todas as lojas do mundo.",
                "release_language": "Em qual idioma o nome do lançamento está escrito? Por favor, verifique novamente se não tiver certeza. Se esta entrada estiver errada, algumas lojas como iTunes e Apple Music rejeitarão o lançamento.",
                "ean": "O Código Universal de Produto ou Número de Artigo Europeu para o lançamento. Códigos válidos têm 13 dígitos. Se você não tiver o seu próprio, geraremos um para você."
            },
            "option": {
                "yes": "Sim",
                "no": "Não",
                "no_exclusive": "Sem exclusividade",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pré-venda 1 semana",
                "preorder_2weeks": "Pré-venda 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Selecionar...",
                "worldwide": "Mundial",
                "only_selected": "Apenas países selecionados",
                "all_except_selected": "Todos, exceto países selecionados"
            },
            "message": {
                "track_name_required": "Por favor, digite o nome da faixa",
                "mix_name_required": "Por favor, digite o nome do mix",
                "mix_name_invalid": "O nome do mix só pode consistir em letras, números, espaços e sublinhados",
                "artist_required": "Por favor, selecione o artista",
                "artist_type_required": "Por favor, selecione o tipo de artista",
                "catalog_duplicate": "O número do catálogo '{{number}}' já foi usado. Por favor, insira outro.",
                "artist_added": "Novo Artista foi adicionado!",
                "track_limit": "Seu limite atual de faixas é {{trackLimit}} faixa(s). Para enviar mais faixas, por favor, atualize sua conta ou entre em contato com nossa equipe de suporte.",
                "select_day": "Por favor, selecione um dia.",
                "form_error": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "ean_invalid": "O valor não é um EAN válido. Se você estiver inserindo um novo lançamento, deixe este campo em branco e geraremos um EAN para você. Se você estiver enviando um catálogo anterior e o EAN não for válido, por favor, entre em contato conosco.",
                "ean_length": "O número EAN deve ter 13 caracteres",
                "artwork_invalid": "Este arquivo é inválido, por favor, certifique-se de que a imagem tenha extensão .jpg, Cores RGB, dimensões 3000 X 3000 e até 4MB.",
                "track_invalid": "Este arquivo é inválido, por favor, certifique-se de codificar corretamente seu arquivo em 16 bits, 44.1 Khz."
            },
            "button": {
                "reset": "Redefinir",
                "save_only": "Salvar apenas",
                "save_and_continue": "Salvar e continuar"
            },
            "modal": {
                "assisted_days": {
                    "header": "Você tem certeza de que deseja ignorar as melhores práticas de data de lançamento?",
                    "body": "Por favor, note que ao selecionar esta opção, sua data de lançamento pode não ser aceita pelas lojas ou ingerida e publicada na data selecionada. Além disso, você está reduzindo fortemente as oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_created": {
                    "header": "Lançamento criado!",
                    "body": "Seu lançamento foi criado com sucesso!",
                    "button": {
                        "close": "Fechar"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Declaração de Transferência de Lançamento",
                    "body": "Eu verifiquei e completei todas as informações necessárias para este lançamento e agora está pronto para UPLOAD.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Ver Lançamento",
        "form": {
            "label": {
                "required": "Obrigatório",
                "name": "Nome do Lançamento",
                "version": "Versão do Lançamento",
                "subuser": "Sub-Usuário",
                "label": "Selo",
                "copyright": "Direitos Autorais ©",
                "copyright_year": "Ano dos Direitos Autorais ©",
                "copyright_publisher": "Direitos Autorais ℗",
                "copyright_publisher_year": "Ano dos Direitos Autorais ℗",
                "genre": "Gênero",
                "subgenre": "Subgênero",
                "catalog_number": "Número do Catálogo",
                "artwork": "Arte",
                "artwork_alt": "Sua arte",
                "new_release": "É um Novo Lançamento?",
                "original_release_date": "Data de lançamento original",
                "official_release_date": "Data de lançamento oficial",
                "backcatalog": "Catálogo Anterior",
                "assisted_dates": "Datas Assistidas",
                "exclusive_store_release_date": "Data de lançamento exclusiva na loja",
                "additional_metadata": "Metadados Adicionais",
                "release_description": "Descrição do Lançamento",
                "release_language": "Idioma do Nome do Lançamento",
                "auto_detect_language": "Detecção Automática (Idioma)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Gerar automaticamente (ean)",
                "territories": "Territórios",
                "countries": "Países",
                "youtube_declaration_header": "DECLARAÇÃO DE ID DE CONTEÚDO DO YOUTUBE",
                "youtube_declaration_intro": "Para optar pelo ID de Conteúdo do YouTube para este lançamento, você deve garantir que atenda a TODOS os seguintes requisitos:",
                "youtube_declaration_certify": "Eu, <strong>{{firstName}} {{lastName}}</strong>, sob pena de perjúrio, certifico que as informações acima são verdadeiras e corretas.",
                "youtube_declaration_point1": "Tenho direitos suficientes sobre o material.",
                "youtube_declaration_point2": "Todo o conteúdo de referência é suficientemente distinto.",
                "youtube_declaration_point3": "Tenho referências individuais para cada peça de propriedade intelectual.",
                "youtube_declaration_point4": "O conteúdo entregue <strong>não</strong> é nenhum dos seguintes: domínio público, conteúdo licenciado não exclusivamente, clipes de outras fontes usados sob princípios de uso justo, imagens de jogabilidade de vídeo (por outro que não o editor do jogo), gravações de karaokê, remasterização sem permissão, gravações semelhantes, conteúdo dublado, aceleração/desaceleração, efeitos sonoros, trilhas sonoras, mixagens contínuas de DJ, mashups, listas de contagem regressiva ou qualquer outro conteúdo proibido ou inelegível nomeado nas Diretrizes de ID de Conteúdo do YouTube listadas abaixo.",
                "youtube_declaration_account": "Entendo que minha conta pode ser desativada e encerrada em caso de violações. Além disso, compreendo plenamente que posso ser responsável por quaisquer taxas, danos, despesas legais ou quaisquer outras despesas que possam surgir.",
                "youtube_declaration_guidelines": "De acordo com as <1><strong>Diretrizes de ID de Conteúdo do YouTube</strong></1>, o conteúdo enviado através deste lançamento é totalmente elegível para o ID de Conteúdo do YouTube.",
                "youtube_content_id_eligible": "Confirmo que meu conteúdo é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "youtube_content_id_not_eligible": "Meu conteúdo não é elegível para <strong>ID de Conteúdo do YouTube</strong>",
                "immersive_audio": "Este Lançamento tem Áudio Imersivo"
            },
            "placeholder": {
                "version": "Deixe em branco se não tiver certeza ou se for um lançamento regular",
                "select_date": "Selecionar data...",
                "copyright": "Normalmente o nome do seu selo",
                "copyright_publisher": "Normalmente o nome do seu selo",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "label": "Selecionar Selo...",
                "subuser": "Selecionar Sub-usuário...",
                "artist": "Selecionar Artista...",
                "genre": "Selecionar Gênero...",
                "subgenre": "Selecionar Subgênero...",
                "ean": "Deixe em branco se não tiver certeza!",
                "release_description": "Algumas palavras sobre seu lançamento. Sem links e endereços de e-mail, por favor. Máximo de 600 caracteres"
            },
            "help_text": {
                "name": "Por favor, não use adições ao nome do lançamento, como LP e EP.",
                "version": "Alguns lançamentos são lançados em mais de uma versão, se for o caso, insira o nome da versão. Se seu lançamento for original/padrão, ignore este campo.",
                "subuser": "Nota: Use este menu suspenso apenas se quiser adicionar um lançamento para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado.",
                "catalog_number": "Insira seu número de catálogo. Normalmente, os selos inserem a abreviação do nome do selo e um número. Ex: {{prefix}}001, {{prefix}}002...",
                "artwork": "Envie formatos JPG, resolução apenas 3000x3000 px, @ 72 dpi",
                "original_release_date": "Data de lançamento original para todas as lojas do mundo.",
                "official_release_date": "Data de lançamento oficial para todas as lojas do mundo.",
                "release_language": "Em qual idioma o nome do lançamento está escrito? Por favor, verifique novamente se não tiver certeza. Se esta entrada estiver errada, algumas lojas como iTunes e Apple Music rejeitarão o lançamento.",
                "ean": "O Código Universal de Produto ou Número de Artigo Europeu para o lançamento. Códigos válidos têm 13 dígitos. Se você não tiver o seu próprio, geraremos um para você."
            },
            "option": {
                "yes": "Sim",
                "no": "Não",
                "no_exclusive": "Sem exclusividade",
                "beatport_2weeks": "Beatport 2 semanas",
                "beatport_4weeks": "Beatport 4 semanas",
                "preorder_1week": "Pré-venda 1 semana",
                "preorder_2weeks": "Pré-venda 2 semanas",
                "traxsource_2weeks": "Traxsource 2 semanas",
                "select": "Selecionar...",
                "worldwide": "Mundial",
                "only_selected": "Apenas países selecionados",
                "all_except_selected": "Todos, exceto países selecionados"
            },
            "message": {
                "track_name_required": "Por favor, digite o nome da faixa",
                "mix_name_required": "Por favor, digite o nome do mix",
                "mix_name_invalid": "O nome do mix só pode consistir em letras, números, espaços e sublinhados",
                "artist_required": "Por favor, selecione o artista",
                "artist_type_required": "Por favor, selecione o tipo de artista",
                "catalog_duplicate": "O número do catálogo '{{number}}' já foi usado. Por favor, insira outro.",
                "artist_added": "Novo Artista foi adicionado!",
                "track_limit": "Seu limite atual de faixas é {{trackLimit}} faixa(s). Para enviar mais faixas, por favor, atualize sua conta ou entre em contato com nossa equipe de suporte.",
                "select_day": "Por favor, selecione um dia.",
                "form_error": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "ean_invalid": "O valor não é um EAN válido. Se você estiver inserindo um novo lançamento, deixe este campo em branco e geraremos um EAN para você. Se você estiver enviando um catálogo anterior e o EAN não for válido, por favor, entre em contato conosco.",
                "ean_length": "O número EAN deve ter 13 caracteres",
                "artwork_invalid": "Este arquivo é inválido, por favor, certifique-se de que a imagem tenha extensão .jpg, Cores RGB, dimensões 3000 X 3000 e até 4MB.",
                "track_invalid": "Este arquivo é inválido, por favor, certifique-se de codificar corretamente seu arquivo em 16 bits, 44.1 Khz."
            },
            "button": {
                "submit": "Enviar Formulário"
            },
            "modal": {
                "assisted_days": {
                    "header": "Você tem certeza de que deseja ignorar as melhores práticas de data de lançamento?",
                    "body": "Por favor, note que ao selecionar esta opção, sua data de lançamento pode não ser aceita pelas lojas ou ingerida e publicada na data selecionada. Além disso, você está reduzindo fortemente as oportunidades de marketing.",
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar"
                    }
                },
                "release_updated": {
                    "header": "Lançamento atualizado!",
                    "body": "Seu lançamento foi atualizado com sucesso!",
                    "button": {
                        "close": "Fechar"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Artista Principal",
            "featuring": "Artista Participante",
            "remixer": "Remixer"
        },
        "placeholder": {
            "selectArtist": "Selecionar Artista..."
        },
        "button": {
            "remove": "Remover",
            "addAnother": "Adicionar outro",
            "createNew": "Criar novo?"
        },
        "modal": {
            "header": "Você tem certeza de que deseja atribuir este artista como Artista Participante?",
            "body": "Por favor, não confunda Artista Participante com um Remixer. Artista Participante deve ser adicionado apenas se você estiver confiante e certo de que este artista não é o Artista Principal ou Remixer.",
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        },
        "label": {
            "order": "Ordem",
            "artistName": "Nome do Artista",
            "artistType": "Tipo de Artista",
            "artists": "Artistas",
            "required": "Obrigatório"
        },
        "help_text": {
            "artists": "Se o lançamento for escrito por mais de <strong>4 Artistas Principais</strong>, por favor, use <strong>Vários Artistas</strong>. Artistas de faixas, remixers e colaboradores devem ser adicionados na etapa de Edição de Faixas."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Faixas",
            "order": "Ordem",
            "trackName": "Nome da Faixa",
            "mixName": "Nome do Mix",
            "file": "Arquivo",
            "albumOnly": "Apenas Álbum",
            "required": "Obrigatório",
            "stereo": "Estéreo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Adicionar outro",
            "remove": "Remover?",
            "onlyAlbum": "Apenas Álbum",
            "mixTypes": {
                "originalMix": "Mix Original",
                "remixOrMix": "Este é um Remix ou Mix"
            }
        },
        "button": {
            "remove": "Remover",
            "addAnother": "Adicionar outro"
        },
        "validation": {
            "trackName": "Por favor, digite o nome da faixa",
            "mixName": "Por favor, digite o nome do mix",
            "mixNameRegex": "O nome do mix só pode consistir em letras, números, espaços e sublinhados",
            "trackFile": "Por favor, selecione o arquivo da faixa",
            "trackFileDolby": "Por favor, selecione o arquivo da faixa dolby atmos",
            "trackFileDuration": "A duração dos arquivos de faixa Estéreo e Dolby deve corresponder",
            "swapTrackAudioTokenRequiredTooltip": "Seu saldo atual de tokens é insuficiente. É necessário pelo menos 1 token para trocar o áudio da faixa."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Artistas",
            "order": "Ordem",
            "artistName": "Nome do Artista",
            "artistType": "Tipo de Artista",
            "required": "Obrigatório"
        },
        "placeholder": {
            "selectArtist": "Selecionar Artista..."
        },
        "help_text": {
            "artists": "Se o lançamento for escrito por mais de <strong>4 Artistas Principais</strong>, por favor, use <strong>Vários Artistas</strong>. Artistas de faixas, remixers e colaboradores devem ser adicionados na etapa de Edição de Faixas."
        },
        "option": {
            "artistType": {
                "main": "Artista Principal",
                "featuring": "Artista Participante",
                "remixer": "Remixer"
            }
        },
        "button": {
            "remove": "Remover",
            "addAnother": "Adicionar outro",
            "createNew": "Criar novo?"
        },
        "message": {
            "errorArtistRequired": "Por favor, selecione o artista",
            "errorArtistTypeRequired": "Por favor, selecione o tipo de artista"
        },
        "modal": {
            "header": "Você tem certeza de que deseja atribuir este artista como Artista Participante?",
            "body": "Por favor, não confunda Artista Participante com um Remixer. Artista Participante deve ser adicionado apenas se você estiver confiante e certo de que este artista não é o Artista Principal ou Remixer.",
            "button": {
                "cancel": "Cancelar",
                "confirm": "Confirmar"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Lojas"
        },
        "placeholder": {
            "search": "Pesquisar loja..."
        },
        "section": {
            "mandatory": "Obrigatório",
            "optional": "Opcional",
            "optional_locked": "Opcional Lojas Adicionais",
            "summary": {
                "read_only": "{{title}} ({{count}} no total)",
                "editable": "{{title}} ({{total}} no total, {{selected}} selecionados)"
            }
        },
        "message": {
            "no_stores": "Nenhuma loja encontrada.",
            "availability": "Beatport está disponível apenas para lançamentos de Dance com selos aprovados pelo Beatport. Traxsource está disponível apenas para lançamentos de Dance com selos aprovados pelo Traxsource.",
            "youtube_declaration": "Por favor, assine primeiro a Declaração do YouTube Content ID.",
            "youtube_ineligible": "Esta loja não é elegível, pois você declarou que não possui os direitos de propriedade. Se isso for declarado falsamente, você poderá ser responsabilizado por uma disputa legal.",
            "youtube_content_id": "Esta loja não se aplica a lançamentos elegíveis para YouTube Content ID porque é entregue tanto para o YouTube Content ID quanto para o YouTube Premium.",
            "beatport": "Beatport só pode ser selecionado quando o gênero for Dance e o selo estiver aprovado para Beatport.",
            "traxsource": "Traxsource só pode ser selecionado quando o gênero for Dance e o selo estiver aprovado para Traxsource.",
            "juno": "JunoDownload só pode ser selecionado quando o gênero for Dance.",
            "contact_support": "Por favor, entre em contato com nossa equipe de suporte para desbloquear essas lojas.",
            "optional_additional_none_selected": "Você não selecionou nenhuma Loja Adicional Opcional. Elas podem ampliar seu alcance. Tem certeza de que deseja ignorá-las?",
            "optional_paid_insufficient_tokens": "Saldo de tokens insuficiente. É necessário pelo menos 1 token para selecionar Lojas Adicionais Opcionais.",
            "optional_paid_insufficient_tokens_with_link": "Seu saldo atual de tokens é insuficiente. É necessário pelo menos 1 token para selecionar Lojas Adicionais Opcionais. <2>Comprar tokens</2> para continuar."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Faixas",
            "order": "Ordem",
            "trackName": "Nome da Faixa",
            "mixName": "Nome do Mix",
            "file": "Arquivo",
            "albumOnly": "Apenas Álbum",
            "required": "Obrigatório",
            "stereo": "Estéreo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Adicionar outro",
            "remove": "Remover?",
            "onlyAlbum": "Apenas Álbum",
            "mixTypes": {
                "originalMix": "Mix Original",
                "remixOrMix": "Este é um Remix ou Mix"
            }
        },
        "button": {
            "remove": "Remover",
            "addAnother": "Adicionar outro"
        },
        "validation": {
            "trackName": "Por favor, digite o nome da faixa",
            "mixName": "Por favor, digite o nome do mix",
            "mixNameRegex": "O nome do mix só pode consistir em letras, números, espaços e sublinhados",
            "trackFile": "Por favor, selecione o arquivo da faixa",
            "trackFileDolby": "Por favor, selecione o arquivo da faixa dolby atmos",
            "trackFileDuration": "A duração dos arquivos de faixa Estéreo e Dolby deve corresponder"
        }
    }
};

export default releasesPT;